import * as ActionTypes from '../actions/actionTypes';

const initialState = { playing: false, speed: 1, next_time: undefined, timer: undefined };

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case ActionTypes.START_PLAYING:
      return {
        ...state,
        playing: true
      };
    case ActionTypes.SET_PLAY_SPEED:
      return {
        ...state,
        speed: action.speed
      };
    case ActionTypes.STOP_PLAYING:
      return {
        ...state,
        playing: false,
        next_time: undefined,
        timer: undefined
      };
    case ActionTypes.SET_TIMER:
      return {
        ...state,
        next_time: action.next_time,
        timer: action.timer
      };
    default:
      return state;
  }
};

export default reducer;



// WEBPACK FOOTER //
// ./src/reducers/play.js